<div *ngIf="!isLoyalty2026Active" class="discover-benefits flex flex-col gap-4">
    <div class="flex flex-row justify-between">
        <h2 class="discover-benefits__title">{{'benefits_kb.discover_your_benefits' | translate}}</h2>
        <div class="discover-benefits__arrows">
            <svg (click)="prevItem()" class="discover-benefits__arrows__arrow-left" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 25 24" fill="none">
                <path d="M12.6667 19.2249L11.9416 18.5249L17.9667 12.4999H5.44165V11.4999H17.9667L11.9416 5.4749L12.6667 4.7749L19.8917 11.9999L12.6667 19.2249Z" fill="#3F4350" />
            </svg>
            <svg (click)="nextItem()" class="discover-benefits__arrows__arrow-right" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 25 24" fill="none">
                <path d="M12.6667 19.2249L11.9416 18.5249L17.9667 12.4999H5.44165V11.4999H17.9667L11.9416 5.4749L12.6667 4.7749L19.8917 11.9999L12.6667 19.2249Z" fill="#3F4350" />
            </svg>
        </div>
    </div>
    <div class="grid grid-cols-4 gap-8 self-stretch">
        <!-- Menú lateral -->
        <div class="col-span-1 hidden md:block">
            <div class="flex flex-col gap-6">
                <app-menu-item *ngFor="let item of menuItems" [item]="item" [isSelected]="(selectedItem$ | async)?.id === item.id" (onSelect)="onSelectMenuItem($event)" [gtmLabel]="'list_' + mapBenefitId(item.id)">
                </app-menu-item>
            </div>
        </div>

        <!-- Contenido -->
        <div class="col-span-4 md:col-span-3 discover-benefits__content grid grid-cols-2 gap-8" *ngIf="selectedItem$ | async as selectedItem">
            <div class="col-span-2 md:col-span-1">
                <div class="discover-benefits__content__title flex items-center justify-between gap-2 pb-4 md:pb-0">
                    <h3>{{ selectedItem.content.title }}</h3>
                    <span *ngIf="selectedItem.isPremium" class="md:hidden discover-benefits__content__title__badge">
                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="9" viewBox="0 0 7 9" fill="none">
                            <path
                                d="M0.769285 8.78578C0.55619 8.78578 0.374682 8.71086 0.224762 8.56102C0.0749207 8.4111 0 8.22959 0 8.0165V3.84078C0 3.62769 0.0749207 3.44618 0.224762 3.29626C0.374682 3.14642 0.55619 3.0715 0.769285 3.0715H1.42857V2.11912C1.42857 1.58856 1.61341 1.13848 1.98309 0.768879C2.3527 0.399197 2.80278 0.214355 3.33333 0.214355C3.86389 0.214355 4.31397 0.399197 4.68357 0.768879C5.05325 1.13848 5.23809 1.58856 5.23809 2.11912V3.0715H5.89738C6.11047 3.0715 6.29198 3.14642 6.4419 3.29626C6.59174 3.44618 6.66666 3.62769 6.66666 3.84078V8.0165C6.66666 8.22959 6.59174 8.4111 6.4419 8.56102C6.29198 8.71086 6.11047 8.78578 5.89738 8.78578H0.769285ZM0.769285 8.30959H5.89738C5.98286 8.30959 6.05309 8.28213 6.10809 8.22721C6.16301 8.17221 6.19047 8.10197 6.19047 8.0165V3.84078C6.19047 3.75531 6.16301 3.68507 6.10809 3.63007C6.05309 3.57515 5.98286 3.54769 5.89738 3.54769H0.769285C0.683809 3.54769 0.613571 3.57515 0.558571 3.63007C0.503651 3.68507 0.47619 3.75531 0.47619 3.84078V8.0165C0.47619 8.10197 0.503651 8.17221 0.558571 8.22721C0.613571 8.28213 0.683809 8.30959 0.769285 8.30959ZM3.33333 6.64293C3.53421 6.64293 3.70345 6.57408 3.84107 6.43638C3.97877 6.29876 4.04762 6.12951 4.04762 5.92864C4.04762 5.72777 3.97877 5.55852 3.84107 5.4209C3.70345 5.2832 3.53421 5.21435 3.33333 5.21435C3.13246 5.21435 2.96321 5.2832 2.82559 5.4209C2.6879 5.55852 2.61905 5.72777 2.61905 5.92864C2.61905 6.12951 2.6879 6.29876 2.82559 6.43638C2.96321 6.57408 3.13246 6.64293 3.33333 6.64293ZM1.90476 3.0715H4.7619V2.11912C4.7619 1.72229 4.62301 1.38499 4.34524 1.10721C4.06746 0.829435 3.73016 0.690546 3.33333 0.690546C2.93651 0.690546 2.59921 0.829435 2.32143 1.10721C2.04365 1.38499 1.90476 1.72229 1.90476 2.11912V3.0715Z"
                                fill="#232323"
                            />
                        </svg>
                        PREMIUM
                    </span>
                </div>
                <img style="height:300px" class="md:hidden w-full object-cover" [src]="selectedItem.content.image" alt="discover-benefits-1" />
                <p class="typography-body-m-regular my-[24px]">{{ selectedItem.content.description }}</p>
                <app-link (onClick)="goToMyRewards()" contentClass="text-primary-default" [size]="'medium'" [gtmLabel]="'link_go-to--my-sales_benefit-list--' + mapBenefitId(selectedItem.id)">{{'benefits_kb.go_to_my_rewards' | translate}}</app-link>
            </div>
            <div class="col-span-1 hidden md:block">
                <img class="w-full h-full object-cover" [src]="selectedItem.content.image" alt="discover-benefits-1" />
            </div>
        </div>
    </div>
</div>

<div *ngIf="isLoyalty2026Active" class="flex flex-col gap-4 loyalty-2026">
    <div class="flex flex-row items-center justify-between">
        <div class="benefits-discover-2026">{{getDiscoverBenefitsTitle() | translate}}</div>
        <a *ngIf="loyaltyTcUrl" [href]="loyaltyTcUrl" target="_blank" rel="noopener noreferrer"
           class="flex items-center gap-1 typography-body-m-regular text-primary-default no-underline hover:underline">
            {{'benefits_kb.loyalty_2026.discover_your_benefits_link' | translate}}
        </a>
    </div>

    <!-- Fila con 3 columnas -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4 md:min-h-[309px]">
        <!-- Columna 1 - 50% -->
        <div class="flex-col flex col-span-1 md:col-span-2 extra-cash justify-between p-6 min-h-[320px]">
            <div>
                <div class="card-title mb-4">{{'benefits_kb.loyalty_2026.real_rewards.title' | translate}}</div>
                <div class="card-description">{{'benefits_kb.loyalty_2026.real_rewards.description' | translate}}</div>
                <div class="card-subtitle">{{getRealRewardsSubtitle() | translate}}</div>
                <app-link [size]="'small'" (onClick)="openPopup(0)">
                     <div class="flex items-center">
                        {{'benefits_we.know_more' | translate}}
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M6.26647 11.5333L5.7998 11.0667L8.86647 8L5.7998 4.93333L6.26647 4.46667L9.7998 8L6.26647 11.5333Z" fill="white"/>
                        </svg>
                    </div>
                </app-link>
            </div>
            <button class="S cosentino-button cursor-pointer custom-loyalty-button gap-2 inline-flex items-center secondary select-none text-center we" (click)="goToMySales()">
                <span class="button-content typography-body-m-medium">{{'benefits_kb.loyalty_2026.real_rewards.action_button' | translate}}</span>
            </button>
        </div>
        <!-- Columna 2 - 25% -->
        <div class="flex-col flex col-span-1 justify-between p-6 displays min-h-[320px]">
            <div>
                <div class="card-title mb-4">{{'benefits_kb.loyalty_2026.custom_displays.title' | translate}}</div>
                <div class="card-description">{{'benefits_kb.loyalty_2026.custom_displays.description' | translate}}</div>
                <app-link [size]="'small'" (onClick)="openPopup(1)">
                     <div class="flex items-center">
                        {{'benefits_we.know_more' | translate}}
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M6.26647 11.5333L5.7998 11.0667L8.86647 8L5.7998 4.93333L6.26647 4.46667L9.7998 8L6.26647 11.5333Z" fill="white"/>
                        </svg>
                    </div>
                </app-link>
            </div>
            <button class="S cosentino-button cursor-pointer custom-loyalty-button gap-2 inline-flex items-center secondary select-none text-center we" (click)="requestExposition()">
                <span class="button-content typography-body-m-medium">{{'benefits_kb.loyalty_2026.custom_displays.action_button' | translate}}</span>
            </button>
        </div>

        <!-- Columna 3 - 25% -->
        <div class="flex-col flex col-span-1 justify-between p-6 displays visibility min-h-[320px]">
            <div>
                <div class="card-title mb-4">{{'benefits_kb.loyalty_2026.featured_recognition.title' | translate}}</div>
                <div class="card-description">{{'benefits_kb.loyalty_2026.featured_recognition.description' | translate}}</div>
                <app-link [size]="'small'" (onClick)="openPopup(2)">
                     <div class="flex items-center">
                        {{'benefits_we.know_more' | translate}}
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M6.26647 11.5333L5.7998 11.0667L8.86647 8L5.7998 4.93333L6.26647 4.46667L9.7998 8L6.26647 11.5333Z" fill="white"/>
                        </svg>
                    </div>
                </app-link>
            </div>
            <button class="S cosentino-button cursor-pointer custom-loyalty-button gap-2 inline-flex items-center secondary select-none text-center we">
                <span class="button-content typography-body-m-medium">{{'benefits_kb.loyalty_2026.featured_recognition.action_button' | translate}}</span>
            </button>
        </div>
    </div>

        <!-- Fila con 3 columnas -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4 md:min-h-[309px]">

        <!-- Columna 1- 25% -->
        <div class="flex-col flex col-span-1 justify-between p-6 eventos min-h-[320px]">
            <div>
                <div class="card-title mb-4">{{'benefits_kb.loyalty_2026.exclusive_networking.title' | translate}}</div>
                <div class="card-description">{{'benefits_kb.loyalty_2026.exclusive_networking.description' | translate}}</div>
                <app-link [size]="'small'" (onClick)="openPopup(3)">
                     <div class="flex items-center">
                        {{'benefits_we.know_more' | translate}}
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M6.26647 11.5333L5.7998 11.0667L8.86647 8L5.7998 4.93333L6.26647 4.46667L9.7998 8L6.26647 11.5333Z" fill="white"/>
                        </svg>
                    </div>
                </app-link>
            </div>
            <button class="S cosentino-button cursor-pointer custom-loyalty-button gap-2 inline-flex items-center secondary select-none text-center we">
                <span class="button-content typography-body-m-medium">{{'benefits_kb.loyalty_2026.exclusive_networking.action_button' | translate}}</span>
            </button>
        </div>

        <!-- Columna 2 - 25% -->
        <div class="flex-col flex col-span-1 justify-between p-6 displays novedades min-h-[320px]">
            <div>
                <div class="card-title mb-4">{{'benefits_kb.loyalty_2026.early_launches.title' | translate}}</div>
                <div class="card-description">{{'benefits_kb.loyalty_2026.early_launches.description' | translate}}</div>
                <app-link [size]="'small'" (onClick)="openPopup(4)">
                     <div class="flex items-center">
                        {{'benefits_we.know_more' | translate}}
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M6.26647 11.5333L5.7998 11.0667L8.86647 8L5.7998 4.93333L6.26647 4.46667L9.7998 8L6.26647 11.5333Z" fill="white"/>
                        </svg>
                    </div>
                </app-link>
            </div>
            <button class="S cosentino-button cursor-pointer custom-loyalty-button gap-2 inline-flex items-center secondary select-none text-center we" (click)="goToMySamples()">
                <span class="button-content typography-body-m-medium">{{'benefits_kb.loyalty_2026.early_launches.action_button' | translate}}</span>
            </button>
        </div>

                <!-- Columna 3 - 50% -->
        <div class="flex-col flex col-span-1 md:col-span-2 extra-cash justify-between locator p-6 min-h-[320px]">
                      <div>
                <div class="card-title mb-4">{{'benefits_kb.loyalty_2026.professional_visibility.title' | translate}}</div>
                <div class="card-description">{{'benefits_kb.loyalty_2026.professional_visibility.description' | translate}}</div>
                <div class="card-subtitle">{{getProfessionalVisibilitySubtitle() | translate}}</div>

                <app-link [size]="'small'" (onClick)="openPopup(5)">
                     <div class="flex items-center">
                        {{'benefits_we.know_more' | translate}}
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M6.26647 11.5333L5.7998 11.0667L8.86647 8L5.7998 4.93333L6.26647 4.46667L9.7998 8L6.26647 11.5333Z" fill="white"/>
                        </svg>
                    </div>
                </app-link>
            </div>
            <button class="S cosentino-button cursor-pointer custom-loyalty-button gap-2 inline-flex items-center secondary select-none text-center we" >
                <span class="button-content typography-body-m-medium">{{'benefits_kb.loyalty_2026.professional_visibility.action_button' | translate}}</span>
            </button>

        </div>
    </div>
</div>

<!-- Modal Popup -->
<div *ngIf="isPopupOpen" class="popup-overlay" (click)="closePopup()">
    <div class="popup-content" (click)="$event.stopPropagation()">
        <!-- Botón cerrar -->
        <button class="popup-close" (click)="closePopup()">
            <span>{{'benefits_kb.close' | translate}}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M5.33333 16.6667L4.16666 15.5L8.66666 11L4.16666 6.5L5.33333 5.33333L9.83333 9.83333L14.3333 5.33333L15.5 6.5L11 11L15.5 15.5L14.3333 16.6667L9.83333 12.1667L5.33333 16.6667Z" fill="#365BCA"/>
            </svg>
        </button>

        <!-- Contenido del popup en dos columnas -->
        <div class="popup-body">
            <!-- Columna izquierda - Contenido -->
            <div class="popup-left flex flex-col gap-4 justify-around  ">
                <div class="popup-label">{{('benefits_kb.loyalty_2026.' + getCurrentBenefit().key + '.label') | translate}}</div>
                <div class="popup-title">{{('benefits_kb.loyalty_2026.' + getCurrentBenefit().key + '.popup_title') | translate}}
                </div>
                <div *ngIf="getCurrentBenefit().key === 'real_rewards' || getCurrentBenefit().key === 'professional_visibility'"
                    class="popup-description1">{{('benefits_kb.loyalty_2026.' + getCurrentBenefit().key + '.popup_description1') | translate}}</div>
                <div class=""
                    [innerHTML]="('benefits_kb.loyalty_2026.' + getCurrentBenefit().key + '.popup_content') | translate"></div>
                <button class="popup-action-btn">{{('benefits_kb.loyalty_2026.' + getCurrentBenefit().key + '.popup_button') |
                    translate}}</button>
            </div>

            <!-- Columna derecha - Imagen -->
            <div class="popup-right">
                <img [src]="'assets/images/my-benefits/2026/' + getCurrentBenefit().image" [alt]="getCurrentBenefit().key" class="popup-image">
            </div>
        </div>

        <!-- Navegación -->
        <div class="popup-navigation">
            <app-link [size]="'small'" (onClick)="prevPopup()">
                <div class="flex items-center gap-1 primaryDefault-color">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M10 12L6 8L10 4" stroke="#365BCA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    {{'benefits_kb.view_previous' | translate}}
                </div>
            </app-link>
            <div class="popup-indicators">
                <span *ngFor="let benefit of popupBenefits; let i = index"
                      class="popup-dot"
                      [class.active]="i === currentPopupIndex"
                      (click)="openPopup(i)"></span>
            </div>
            <app-link [size]="'small'" (onClick)="nextPopup()">
                <div class="flex items-center gap-1 primaryDefault-color">
                    {{'benefits_kb.view_next' | translate}}
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M6 4L10 8L6 12" stroke="#365BCA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </app-link>
        </div>
    </div>
</div>